import { offerings, steps, email, emailText, headshot, tagline, belief, about, contact, socials, year } from "./content";
import Switcher from "./Switcher";
import "./column.css";

export default function Column() {
  return (
    <div className="d3" id="top">
      <a className="d3-skip" href="#main">Skip to content</a>

      <header className="d3-rail">
        <a className="d3-brand" href="#top" aria-label="Bit Haiku home">Bit Haiku</a>
        <nav aria-label="Main navigation">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>
        <span className="d3-rail-note" aria-hidden="true">Software / AI automation / Security</span>
      </header>

      <div className="d3-page">
        <main id="main">
          <section className="d3-hero" aria-labelledby="d3-hero-title">
            <div className="d3-hero-text">
              <p className="d3-tag">Sheet 01 — Custom software &amp; AI automation</p>
              <h1 id="d3-hero-title">
                <span>More</span>
                <span>business.</span>
                <span className="d3-thin">Less</span>
                <span className="d3-thin">busywork.</span>
              </h1>
            </div>
            <aside className="d3-spec" aria-label="How a project goes">
              <p className="d3-tag">Elevation — how a project goes</p>
              <ol>
                {steps.map((step) => (
                  <li key={step.id}>
                    <span className="d3-spec-id">{step.id}</span>
                    <div>
                      <span className="d3-spec-label">{step.label}</span>
                      <h3>{step.title}</h3>
                      <p>{step.text}</p>
                    </div>
                  </li>
                ))}
              </ol>
              <p className="d3-lead">{tagline}</p>
              <a className="d3-cta" href="#contact">Take the first step</a>
            </aside>
          </section>

          <section className="d3-services" id="services" aria-labelledby="d3-services-title">
            <div className="d3-section-head">
              <p className="d3-tag">Sheet 02 — What we do</p>
              <h2 id="d3-services-title">Remove the pain from your processes.</h2>
            </div>
            <div className="d3-columns">
              {offerings.map((offering) => (
                <article key={offering.id} className="d3-col">
                  <span className="d3-col-id">{offering.id}</span>
                  <h3>{offering.title}</h3>
                  <p>{offering.text}</p>
                  <ul>{offering.items.map((item) => <li key={item}>{item}</li>)}</ul>
                </article>
              ))}
            </div>
          </section>

          <section className="d3-belief" aria-labelledby="d3-belief-title">
            <p className="d3-tag">Sheet 03 — How we work</p>
            <h2 id="d3-belief-title">{belief.title}</h2>
            <div className="d3-belief-cols">
              {belief.paragraphs.map((text, i) => (
                <p key={text}><span className="d3-belief-index">{String(i + 1).padStart(2, "0")}</span>{text}</p>
              ))}
            </div>
          </section>

          <section className="d3-about" id="about" aria-labelledby="d3-about-title">
            <figure className="d3-portrait">
              <img src={headshot} alt={about.alt} width="420" height="560" loading="lazy" />
              <figcaption>{about.name} — {about.role}</figcaption>
            </figure>
            <div className="d3-about-copy">
              <p className="d3-tag">Sheet 04 — Who you’ll work with</p>
              <h2 id="d3-about-title">{about.title}</h2>
              {about.paragraphs.map((text) => <p key={text}>{text}</p>)}
              <a className="d3-inline" href="#contact">{about.cta} ↗</a>
            </div>
          </section>

          <section className="d3-contact" id="contact" aria-labelledby="d3-contact-title">
            <p className="d3-tag">Sheet 05 — Get in touch</p>
            <h2 id="d3-contact-title">
              <span>What would</span>
              <span>simplicity</span>
              <span>feel like?</span>
            </h2>
            <div className="d3-contact-row">
              <p>{contact.lines.map((line) => <span key={line}>{line}<br /></span>)}</p>
              <a className="d3-email" href={email}>{emailText} ↗</a>
            </div>
          </section>
        </main>

        <footer className="d3-footer">
          <span>© {year} Bit Haiku LLC</span>
          <div>{socials.map((s) => <a key={s.label} href={s.href} target="_blank" rel="noreferrer">{s.label}</a>)}</div>
        </footer>
      </div>
      <Switcher current={3} />
    </div>
  );
}
